import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import ReactMarkdown from 'react-markdown';
import { Link } from 'gatsby';

export const OfferSection = ({ offer }: any) => {
  return (
    <section className="offersection">
      <div className="container">
        <div className="page-heading">
          <div className="page-heading-title title-with-line">
            {offer.title}
          </div>
        </div>
        <div className="offersection-content">
          <div className="offersection-image">
            {offer.image && (
              <GatsbyImage
                image={offer.image.localFile.childImageSharp.gatsbyImageData}
                alt={offer.image?.alternativeText ?? ''}
              />
            )}
          </div>
          <ReactMarkdown className="offersection-heading">
            {offer.heading}
          </ReactMarkdown>
          <p className="offersection-desc">{offer.description}</p>
          <Link to={offer.ctaLink}>
            <button type="button" className="offersection-button">
              {offer.ctaBtn}
            </button>
          </Link>
        </div>
        {offer.listItem && (
          <div className="offersection-bonus">
            {offer.listItem.map((item: any) => (
              <div className="bonus-wrapper">
                {item.title && <h3 className="bonus-title">{item.title}</h3>}
                <ReactMarkdown className="bonus-list">
                  {item.list}
                </ReactMarkdown>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
